import type { ZodError } from 'zod';

export function formatZodErrorIssues(error: ZodError): string {
  return error.issues
    .map(issue =>
      issue.path.length > 0
        ? `${issue.path.join('.')}: ${issue.message}`
        : issue.message
    )
    .join('; ');
}
